//@ts-nocheck
//@ts-nocheck
import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Grid,
  Button,
  TextField,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import {
  GoogleMap,
  InfoWindow,
  Marker,
  Polyline,
} from "@react-google-maps/api";
import { useTranslation } from "react-i18next";
import api from "../../utils/Url";
import CustomLabel from "../../CustomLable";
import { useFormik } from "formik";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import "./style.css";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const sppeddata = [
  { value: 1, label: "1x" },
  { value: 2, label: "2x" },
  { value: 3, label: "3x" },
  { value: 4, label: "4x" },
];

export default function VehicleHistory() {
  const { t } = useTranslation();

  const [VehicleNos, setVehicleNos] = useState<any[]>([]);
  const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
  const [vehicles, setVehicles] = useState<any[]>([]);
  const [activeVehicle, setActiveVehicle] = useState<any>(null);
  const [isMap, setMap] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [center] = useState({ lat: 26.447965, lng: 80.3432 });
  const mapRef = useRef<any>(null);

  /* ---------------- FORM ---------------- */
  const formik = useFormik({
    initialValues: {
      trackDate: new Date().toISOString().split("T")[0],
    },
    onSubmit: () => { },
  });

  /* ---------------- VEHICLE LIST ---------------- */
  useEffect(() => {
    fetchVehicleNos();
  }, []);

  const fetchVehicleNos = async () => {
    const res = await api.get("Rep/GetVehiclesm");

    const arr = res.data.data.map((x: any) => ({
      label: x.vehicleNo,
      value: x.vehicleNo,
      itemMasterId: x.itemMasterid,
    }));

    setVehicleNos(arr);
  };

  /* ---------------- MAP DATA ---------------- */
  const getMapData = useCallback(async () => {
    if (!selectedVehicle) return;

    setIsLoading(true);
    setMap(false);

    const payload = {
      fromDate: formik.values.trackDate,
      toDate: formik.values.trackDate,
      itemmasterid: selectedVehicle.itemMasterId,
      vehicleno: null,
    };

    try {
      const res = await api.post(
        "https://vtscombined.mssplonline.in/Mng/VehicleHistory",
        payload
      );

      const history = res.data?.data?.vehiclehistory || [];
      const emp = res.data?.data?.empsm || {};

      // sort by time (important for route drawing)
      const sorted = [...history].sort(
        (a, b) => new Date(a.trackTime).getTime() - new Date(b.trackTime).getTime()
      );

      const mapped = sorted.map((x: any, i: number) => ({
        id: i,
        vehicleNo: emp.vehicleNo || selectedVehicle.value,
        lat: x.lattitude,
        lng: x.longitude,
        speed: x.speed ?? 0,
        tracktime: x.trackTime
          ? new Date(x.trackTime).toLocaleString()
          : "__",
        empName: emp.driver ?? "__",
        empMobileNo: emp.mobile ?? "__",
        icon:
          (x.speed ?? 0) === 0
            ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
            : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
      }));

      setVehicles(mapped);
      setMap(true);

      // auto-fit bounds
      if (mapped.length && mapRef.current) {
        const bounds = new window.google.maps.LatLngBounds();
        mapped.forEach((v: any) =>
          bounds.extend(new window.google.maps.LatLng(v.lat, v.lng))
        );
        mapRef.current.fitBounds(bounds);
      }
    } catch (err) {
      console.error("Vehicle history error", err);
    } finally {
      setIsLoading(false);
    }
  }, [formik.values.trackDate, selectedVehicle]);

  /* ---------------- UI ---------------- */
  return (
    <div>
      <Grid container spacing={2} justifyContent="center">
        <Grid xs={12} sm={3} md={3} item>
          <TextField
            type="date"
            name="trackDate"
            label={<CustomLabel text={t("text.TrackingDate")} />}
            value={formik.values.trackDate}
            onChange={formik.handleChange}
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
            style={{ backgroundColor: "#fff" }}
          />
        </Grid>

        <Grid xs={12} sm={3} md={3} item>
          <Autocomplete
            options={VehicleNos}
            onChange={(e, v) => setSelectedVehicle(v)}
            fullWidth
            size="small"
            style={{ backgroundColor: "#fff" }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={<CustomLabel text={t("text.SelectVehicleNo")} />}
              />
            )}
          />
        </Grid>

        <Grid xs={12} sm={3} md={3} item>
          <Autocomplete
            options={sppeddata}
            fullWidth
            size="small"
            style={{ backgroundColor: "#fff" }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={<CustomLabel text={t("text.Speed")} />}
              />
            )}
          />
        </Grid>

        <Grid xs={12} sm={2} md={2} item>
          <Button
            fullWidth
            startIcon={<PlayArrowIcon />}
            style={{
              backgroundColor: "var(--header-background)",
              color: "white",
            }}
            onClick={getMapData}
          >
            Playback
          </Button>
        </Grid>

        {isMap && (
          <Grid item xs={12}>
            <div style={{ border: "1px solid black" }}>
              {isLoading ? (
                <CircularProgress />
              ) : (
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={12}
                  onLoad={(map) => (mapRef.current = map)}
                >
                  {vehicles.map((v, i) => (
                    <Marker
                      key={v.id}
                      position={{ lat: v.lat, lng: v.lng }}
                      icon={{
                        url: v.icon,
                        scaledSize: new window.google.maps.Size(50, 50),
                      }}
                      label={{
                        text: `${i + 1}`,
                        className: "marker-label",
                      }}
                      onMouseOver={() => setActiveVehicle(v)}
                      onMouseOut={() => setActiveVehicle(null)}
                    >
                      {activeVehicle?.id === v.id && (
                        <InfoWindow>
                          <div>
                            <div><strong>Serial No:</strong> {i + 1}</div>
                            <div><strong>Vehicle No:</strong> {v.vehicleNo}</div>
                            <div><strong>Speed:</strong> {v.speed}</div>
                            <div><strong>Date & Time:</strong> {v.tracktime}</div>
                            <div><strong>Driver:</strong> {v.empName}</div>
                            <div><strong>Mobile:</strong> {v.empMobileNo}</div>
                          </div>
                        </InfoWindow>
                      )}
                    </Marker>
                  ))}

                  <Polyline
                    path={vehicles.map((v) => ({
                      lat: v.lat,
                      lng: v.lng,
                    }))}
                    options={{
                      strokeColor: "#6190c9",
                      strokeOpacity: 1,
                      strokeWeight: 3,
                    }}
                  />
                </GoogleMap>
              )}
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
}




















// import React, { useEffect, useRef, useState } from "react";
// import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import {
//   Card,
//   Grid,
//   CardContent,
//   Typography,
//   Divider,
//   Switch,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   TextField,
//   DialogActions,
//   Stack,
//   Paper,
//   CircularProgress,
//   Select,
//   MenuItem,
//   Radio,
//   FormLabel,
//   Autocomplete,
//   Checkbox,
//   ListItemText,
//   RadioGroup,
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import api from "../../utils/Url";
// import Box from "@mui/material/Box";

// import { toast } from "react-toastify";
// import {
//   GoogleMap,
//   InfoWindow,
//   LoadScript,
//   Marker,
//   Polyline,
// } from "@react-google-maps/api";
// import CustomLabel from "../../CustomLable";
// import { styled } from "@mui/system";
// import { useFormik } from "formik";
// import PlayArrowIcon from "@mui/icons-material/PlayArrow";

// import "./style.css"




// const containerStyle = {
//   width: "100%",
//   height: "500px",
// };

// interface MenuPermission {
//   isAdd: boolean;
//   isEdit: boolean;
//   isPrint: boolean;
//   isDel: boolean;
// }

// const sppeddata = [
//   { value: 1, label: "1x" },
//   { value: 2, label: "2x" },
//   { value: 3, label: "3x" },
//   { value: 4, label: "4x" },
// ];

// export default function VehicleHistory() {
//   const { t } = useTranslation();

//   const [isType, setType] = useState<any>([
//     { value: "-1", label: t("text.VehicleType") },
//   ]);

//   const [isLoading, setIsLoading] = useState(true);

//   const [isMap, setMap] = useState<any>(false);

//   const [vNo, setVNo] = useState<any>("");

//   const navigate = useNavigate();



//   useEffect(() => {
//     getVehicleNo();
//   }, []);

//   const [VehicleNos, setVehicleNos] = useState<any>([
//     { value: "-1", label: t("text.VehicleNo") },
//   ]);

//   const getVehicleNo = () => {
//     const collectData = {
//       orderby: "",
//       pageNo: 0,
//       pageSize: 0,
//       intnotnullvalue1: 0,
//       userId: "",

//       str1: "",
//       str2: "",
//       str3: "",
//       str4: "",
//       str5: "",
//       intvalue1: 0,
//       intvalue2: 0,
//       intvalue3: 0,
//       intvalue4: 0,
//       intnotnullvalue2: 0,
//       intnotnullvalue3: 0,
//       date1: new Date().toISOString(),
//       date2: new Date().toISOString(),
//       date3: new Date().toISOString(),
//       date4: new Date().toISOString(),
//       dec1: 0,
//       dec2: 0,
//       dec3: 0,
//       dec4: 0,
//       flag: true,
//       data: "",
//       success: true,
//       error: "",
//       selectPerindex: 0,
//       show: true,
//     };
//     api.post(`Dashboard/GetvVehicleNo`, collectData).then((res) => {
//       const arr = res?.data?.data.map((item: any) => ({
//         label: item.vehicleNo,
//         value: item.vehicleNo,
//       }));
//       setVehicleNos(arr);
//     });
//   };

//   const formatTrackTime = (tracktime: string) => {
//     const trackTime = new Date(tracktime);

//     const day = trackTime.getDate().toString().padStart(2, "0");
//     const month = (trackTime.getMonth() + 1).toString().padStart(2, "0");
//     const year = trackTime.getFullYear();
//     const hours = trackTime.getHours().toString().padStart(2, "0");
//     const minutes = trackTime.getMinutes().toString().padStart(2, "0");
//     const seconds = trackTime.getSeconds().toString().padStart(2, "0");

//     return `${day}-${month}-${year} (Time:- ${hours}:${minutes}:${seconds})`;
//   };

//   const [vehicles, setVehicles] = useState<any>([]);
//   const [activeVehicle, setActiveVehicle] = useState<any>(null);
//   const [center, setCenter] = useState({ lat: 26.447965, lng: 80.3432 });
//   const mapRef: any = useRef(null);

//   // Fetch the vehicle data from API
//   const getMapData = () => {
//     const collectData = {
//       where: vNo ? vNo : "",
//       orderby: "",
//       pageNo: 0,
//       pageSize: 0,
//       intnotnullvalue1: 0,
//       userId: "",
//       parameterValues: [""],
//       str1: "",
//       str2: "",
//       str3: "",
//       str4: formik.values.trackDate,
//       str5: "",
//       intvalue1: 0,
//       intvalue2: 0,
//       intvalue3: 0,
//       intvalue4: 0,
//       intnotnullvalue2: 0,
//       intnotnullvalue3: 0,
//       date1: new Date().toISOString(),
//       date2: new Date().toISOString(),
//       date3: new Date().toISOString(),
//       date4: new Date().toISOString(),
//       dec1: 0,
//       dec2: 0,
//       dec3: 0,
//       dec4: 0,
//       flag: true,
//       data: "",
//       success: true,
//       error: "",
//       selectPerindex: 0,
//       show: true,
//     };

//     api
//       .post(`vVehicletrackHis/GetvVehicletrackHis`, collectData)
//       .then((res) => {
//         const arr = res?.data?.data?.map((item: any) => ({
//           vehicleNo: item?.vehicleNo,
//           lat: item.lattitude,
//           lng: item.longitude,
//           id: item.id,
//           speed: item.speed,
//           tracktime: item.trackTime ? formatTrackTime(item.trackTime) : "__",
//           empMobileNo: item.empMobileNo,
//           empName: item.empName,
//           // vehicleTypename: item.vehicleTypename,

//           icon:
//             item.speed === 0
//               ? "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-red-truck-transportation-png-image_11507611.png"
//               : "https://png.pngtree.com/png-vector/20240128/ourmid/pngtree-green-truck-transport-png-image_11508688.png",
//         }));

//         setIsLoading(false);
//         setVehicles(arr);
//         setCenter(calculateCenter(arr));

//         if (arr.length > 0) {
//           adjustZoomLevel(arr);
//         }
//       });
//   };

//   const calculateCenter = (vehicles: any) => {
//     if (vehicles.length === 0) {
//       return { lat: 26.447965, lng: 80.3432 }; // Default center if no vehicles
//     }

//     const latitudes = vehicles.map((vehicle: any) => vehicle.lat);
//     const longitudes = vehicles.map((vehicle: any) => vehicle.lng);

//     const avgLat =
//       latitudes.reduce((sum: any, lat: any) => sum + lat, 0) / latitudes.length;
//     const avgLng =
//       longitudes.reduce((sum: any, lng: any) => sum + lng, 0) /
//       longitudes.length;

//     return { lat: avgLat, lng: avgLng }; // Return the center point
//   };

//   // Adjust the zoom level based on the spread of the vehicles
//   const adjustZoomLevel = (vehicles: any) => {
//     const bounds = new window.google.maps.LatLngBounds();

//     vehicles.forEach((vehicle: any) => {
//       bounds.extend(new window.google.maps.LatLng(vehicle.lat, vehicle.lng));
//     });

//     if (mapRef.current) {
//       mapRef.current.fitBounds(bounds); // Fit the map to the bounds of all vehicles
//     }
//   };

//   const handleMarkerMouseOver = (vehicle: any) => {
//     setActiveVehicle(vehicle);
//   };

//   const handleMarkerMouseOut = () => {
//     setActiveVehicle(null);
//   };

//   const formik = useFormik({
//     initialValues: {
//       genderID: -1,
//       genderName: "",
//       genderCode: "",
//       trackDate: new Date().toISOString().split("T")[0],
//     },
//     onSubmit: async (values) => {
//       //   const response = await api.post(
//       //     `Gender/AddUpdateGenderMaster`,
//       //     values
//       //   );
//       //   try {
//       //     setToaster(false);
//       //     toast.success(response.data.mesg);
//       //     navigate("/master/GenderMaster");
//       //   } catch (error) {
//       //     setToaster(true);
//       //     toast.error(response.data.mesg);
//       //   }
//     },
//   });

//   return (
//     <div>
//       <Grid
//         container
//         spacing={2}
//         style={{
//           // backgroundColor:'red',
//           //marginTop: "2vh",
//           //marginTop: "2vh",
//           justifyContent: "center",
//         }}
//       >
//         <Grid xs={12} sm={3} md={3} item>
//           <TextField
//             type="date"
//             id="trackDate"
//             name="trackDate"
//             label={
//               <CustomLabel text={t("text.TrackingDate")} required={false} />
//             }
//             value={formik.values.trackDate}
//             placeholder={t("text.TrackingDate")}
//             style={{ backgroundColor: "#ffff" }}
//             size="small"
//             fullWidth
//             onChange={formik.handleChange}
//             onBlur={formik.handleBlur}
//             InputLabelProps={{ shrink: true }}
//           />
//         </Grid>
//         <Grid xs={12} sm={3} md={3} item>
//           <Autocomplete
//             //multiple
//             disablePortal
//             id="combo-box-demo"
//             options={VehicleNos}
//             onChange={(event: any, newValue: any) => {
//               console.log(newValue?.value);
//               setVNo(newValue?.value);
//             }}
//             fullWidth
//             size="small"
//             //disableCloseOnSelect
//             style={{ backgroundColor: "#ffff" }}
//             renderInput={(params: any) => (
//               <TextField
//                 {...params}
//                 label={<CustomLabel text={t("text.SelectVehicleNo")} />}
//               />
//             )}
//           />
//         </Grid>

//         <Grid xs={12} sm={3} md={3} item>
//           <Autocomplete
//             // multiple
//             disablePortal
//             id="combo-box-demo"
//             options={sppeddata}
//             onChange={(event: any, newValue: any) => {
//               console.log(newValue?.value);
//             }}
//             fullWidth
//             size="small"
//             // disableCloseOnSelect
//             style={{ backgroundColor: "#ffff" }}
//             renderInput={(params: any) => (
//               <TextField
//                 {...params}
//                 label={<CustomLabel text={t("text.Speed")} />}
//               />
//             )}
//           />
//         </Grid>

//         <Grid xs={12} sm={2} md={2} item>
//           <Button
//             type="submit"
//             fullWidth
//             startIcon={<PlayArrowIcon />}
//             style={{
//               backgroundColor: "var(--header-background)",
//               color: "white",
//             }}
//             onClick={() => {
//               getMapData();
//               setMap(true);
//             }}
//           >
//             Playback
//           </Button>
//         </Grid>

//         {isMap && (
//           <Grid item xs={12} sm={12} lg={12}>
//             <div
//               style={{
//                 border: "1px solid black",
//                 boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
//               }}
//             >
//               {/* <LoadScript googleMapsApiKey="AIzaSyDxp8MamOh_0gBNHBq4m3bgCIgksc4YYgQ"> */}
//               {isLoading ? (
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                   }}
//                 >
//                   <CircularProgress />
//                 </div>
//               ) : (
//                 <GoogleMap
//                   mapContainerStyle={containerStyle}
//                   center={center}
//                   zoom={70} // Default zoom, will be adjusted by `fitBounds`
//                   onLoad={(map: any) => (mapRef.current = map)}
//                 >
//                   {vehicles.map((vehicle: any, index: any) => (
//                     <Marker
//                       key={vehicle.id}
//                       position={{ lat: vehicle.lat, lng: vehicle.lng }}
//                       icon={{
//                         url: vehicle.icon,
//                         scaledSize: new window.google.maps.Size(50, 50),
//                         origin: new window.google.maps.Point(0, 0),
//                         anchor: new window.google.maps.Point(25, 25),
//                       }}

//                       label={{
//                         text: `${index + 1}`,
//                         fontSize: "14px",
//                         fontWeight: "bold",
//                         color: "#f73905",
//                         className: 'marker-label'
//                       }}
//                       onMouseOver={() => handleMarkerMouseOver(vehicle)} // Show vehicle number on hover
//                       onMouseOut={handleMarkerMouseOut} // Hide info window on hover out
//                     >




//                       {activeVehicle && activeVehicle.id === vehicle.id && (
//                         <InfoWindow>
//                           <div>

//                             <div><strong>Serial No: </strong>{index + 1}</div>
//                             <div>
//                               <strong>Vehicle No: </strong>
//                               {vehicle.vehicleNo}
//                             </div>

//                             <div>
//                               <strong>Speed: </strong>
//                               {vehicle.speed}
//                             </div>

//                             <div>
//                               <strong>Date & Time: </strong>
//                               {vehicle.tracktime}
//                             </div>

//                             <div>
//                               <strong>Driver: </strong>
//                               {vehicle.empName}
//                             </div>

//                             <div>
//                               <strong>Mobile Number: </strong>
//                               {vehicle.empMobileNo}
//                             </div>
//                           </div>
//                         </InfoWindow>
//                       )}



//                     </Marker>
//                   ))}


//                   <Polyline
//                     path={vehicles.map((vehicle: any) => ({ lat: vehicle.lat, lng: vehicle.lng }))}
//                     options={{
//                       strokeColor: "#6190c9",
//                       strokeOpacity: 1,
//                       strokeWeight: 3,

//                     }}
//                   />
//                 </GoogleMap>
//               )}
//               {/* </LoadScript> */}
//             </div>
//           </Grid>
//         )}
//       </Grid>
//     </div>
//   );
// }
